import React from 'react'
import css from './style.css'

const Checkbox = (props) => {
  const checkboxClasses = [
    css.checkbox,
    props.checked ? css.checked : ''
  ].join(' ')

  const labelClasses = [
    css.label,
    props.formBlock ? css.formBlock : '',
    props.children ? css.labelSpacing : ''
  ].join(' ')

  return (
    <label className={labelClasses}>
      {props.children}
      <input
        type='checkbox'
        checked={props.checked}
        onChange={props.onChange} />
      <div className={checkboxClasses} />
    </label>
  )
}

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/checkbox/index.js